export type ModuleName = "goalsProgress"
export const MODULE_NAME: ModuleName = "goalsProgress"
